"use client";
import {HEADING_VARIANTS} from "./heading";
import {useBreakpointValue} from "@chakra-ui/react";
import {TEXT_VARIANTS} from "./text";

export const useSectionHeadingVariant = () => {
  return useBreakpointValue({
    base: HEADING_VARIANTS.HEADLINE3,
    md: HEADING_VARIANTS.HEADLINE2,
  });
};

export const useTextVariants = () => {
  return useBreakpointValue({
    base: TEXT_VARIANTS.BODY3,
    md: TEXT_VARIANTS.BODY2,
  });
};
